import React from "react";
import { connect } from 'react-redux';
import { Button, notification, Icon } from 'antd';
import moment from "moment";
import Request from "../../request";

class TimerMini extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            hours: 0,
            minutes: 0,
            seconds: 0,
            stop: true,
            latitude: 0,
            longitude: 0,
            intervalId: null,
            activeUser: {},
            companyDetails: {}
        }
    }

    componentDidMount() {
        this.fetchLocation();
        this.getActiveUser();
        this.initializeTimer();
    }

    componentWillUnmount() {
        if (this.state.intervalId) clearInterval(this.state.intervalId);
    }

    // ✅ Initialize timer from localStorage or server
    initializeTimer = async () => {
        const storedStartTime = localStorage.getItem("timerStartTime");
        if (storedStartTime) {
            const startMoment = moment(storedStartTime);
            const now = moment();
            const diffSeconds = now.diff(startMoment, "seconds");

            const hours = Math.floor(diffSeconds / 3600);
            const minutes = Math.floor((diffSeconds % 3600) / 60);
            const seconds = diffSeconds % 60;

            this.setState({ hours, minutes, seconds, stop: false }, this.startInterval);
        } else {
            this.getLoginData();
        }
    }

    // ✅ Start interval safely
    startInterval = () => {
        if (!this.state.intervalId) {
            const intervalId = setInterval(this.timerStart, 1000);
            this.setState({ intervalId });
        }
    }

    getLoginData = async () => {
        let response = await Request.getLoginTime();
        if (response.success && response.lastLogin && !response.lastLogin.logoutAt) {
            let loginTime = moment(response.lastLogin.loginAt);
            let diffSeconds = moment().diff(loginTime, "seconds");

            const hours = Math.floor(diffSeconds / 3600);
            const minutes = Math.floor((diffSeconds % 3600) / 60);
            const seconds = diffSeconds % 60;

            this.setState({ hours, minutes, seconds, stop: false }, this.startInterval);
        }
    }

    success = (position) => {
        this.setState({ latitude: position.coords.latitude, longitude: position.coords.longitude });
    }

    error = (err) => { }

    fetchLocation = () => {
        navigator.geolocation.getCurrentPosition(this.success, this.error);
    }

    getActiveUser = async () => {
        let activeUser = JSON.parse(localStorage.getItem('user')) || {};
        let companyDetails = await Request.getCompanySetting({ businessId: activeUser.businessId });
        this.setState({ activeUser, companyDetails });
    }

    timerStart = () => {
        let { seconds, minutes, hours } = this.state;
        seconds += 1;
        if (seconds > 59) {
            minutes += 1;
            seconds = 0;
        }
        if (minutes > 59) {
            hours += 1;
            minutes = 0;
        }
        this.setState({ hours, minutes, seconds });
    }

    async checkLoginLogoutTime() {
        const { shiftTiming } = this.state.activeUser;
        if (!shiftTiming) return {};
        const timing = shiftTiming.split(' - ');
        const shiftStartTime = moment(timing[0], "HH:mm:ss A");
        const shiftEndTime = moment(timing[1], 'HH:mm:ss A');
        return { shiftStartTime, shiftEndTime };
    }

    handleTimerStart = async () => {
        this.setState({ loading: true });
        let lateLoginReason;
        const { activeUser, companyDetails } = this.state;

        if (activeUser.shiftTiming && companyDetails.promptForEarlyLoginLogout) {
            let timing = await this.checkLoginLogoutTime();
            let newShiftStartTime = timing.shiftStartTime.add(5, 'minutes');
            if (moment() > newShiftStartTime) {
                lateLoginReason = prompt('Enter Reason For Late Login');
            }
        }

        if (lateLoginReason === null || lateLoginReason === "") {
            notification.error({ message: 'Enter Reason For Late Login First' });
            this.setState({ stop: true, loading: false });
            return;
        }

        let location = { latitude: this.state.latitude, longitude: this.state.longitude };
        let response = await Request.startTimer({ location, lateLoginReason, loginTime: moment() });

        if (response.error) {
            notification.error({ message: response.message });
            this.setState({ stop: true, loading: false });
        } else {
            // ✅ Store start time in localStorage
            localStorage.setItem("timerStartTime", moment().toISOString());
            this.setState({ stop: false, loading: false, hours: 0, minutes: 0, seconds: 0 }, this.startInterval);
        }
    }

    handleTimerStop = async () => {
        this.setState({ loading: true });
        const { activeUser, companyDetails } = this.state;
        let earlyLogoutReason;

        if (activeUser.shiftTiming && companyDetails.promptForEarlyLoginLogout) {
            const timing = await this.checkLoginLogoutTime();
            if (moment() < timing.shiftEndTime) {
                earlyLogoutReason = prompt('Enter Reason For Early Logout First');
            }
        }

        if (earlyLogoutReason === null || earlyLogoutReason === "") {
            notification.error({ message: 'Enter Reason For Early Logout' });
            this.setState({ loading: false });
            return;
        }

        let response = await Request.stopTimer({ earlyLogoutReason, logoutTime: moment() });

        if (response.error) {
            notification.error({ message: response.msg });
            this.setState({ loading: false });
            return;
        }

        // ✅ Remove start time from localStorage and clear interval
        localStorage.removeItem("timerStartTime");
        clearInterval(this.state.intervalId);

        this.setState({
            stop: true,
            minutes: 0,
            seconds: 0,
            hours: 0,
            loading: false,
            intervalId: null
        });
    }

    render() {
        const { hours, minutes, seconds, stop, loading } = this.state;
        const dotColor = stop ? "#f5222d" : "#52c41a";

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    background: "#fff",
                    borderRadius: "25px",
                    padding: "6px 12px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    gap: "10px",
                }}
            >
                <a href="/timer" style={{ display: "flex", alignItems: "center", gap: "10px", position: "relative" }}>
                    <div style={{ position: "relative" }}>
                        <Icon type="clock-circle" style={{ fontSize: 18, color: "#1890ff" }} />
                        <span
                            style={{
                                position: "absolute",
                                top: "-3px",
                                right: "-3px",
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                                backgroundColor: dotColor,
                                animation: "blink 1s infinite",
                            }}
                        />
                    </div>
                    <span style={{ fontWeight: 500, fontSize: "16px", color: "#333", minWidth: "75px", display: "inline-block" }}>
                        {`${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`}
                    </span>
                </a>

                <div>
                    {stop ? (
                        <Button
                            type="primary"
                            icon="caret-right"
                            size="small"
                            loading={loading}
                            onClick={this.handleTimerStart}
                            style={{ borderRadius: "20px", padding: "0 14px", backgroundColor: "#52c41a", borderColor: "#52c41a", fontWeight: 500 }}
                        >
                            Start
                        </Button>
                    ) : (
                        <Button
                            type="danger"
                            icon="pause"
                            size="small"
                            loading={loading}
                            onClick={this.handleTimerStop}
                            style={{ borderRadius: "20px", padding: "0 14px", fontWeight: 500 }}
                        >
                            Stop
                        </Button>
                    )}
                </div>

                <style>
                    {`
                        @keyframes blink {
                            0%, 50%, 100% { opacity: 1; }
                            25%, 75% { opacity: 0.3; }
                        }
                    `}
                </style>
            </div>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(TimerMini);
